export default "__VITE_ASSET__tkHXU3U8__"